import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'tog-inline-spinner-loader',
  templateUrl: './inline-spinner-loader.component.html',
  styleUrls: ['./inline-spinner-loader.component.scss']
})
export class InlineSpinnerLoaderComponent implements OnInit {
  isActive: boolean = false;
  canHide: boolean = false;
  attemptedToHide: boolean = false;
  attemptedToHideDelay: number = 0;
  tryToHide: any; // for the interval

  // by default the loaders will stay up for at least this many milliseconds:
  @Input() timeout: number = 200;

  constructor() { }

  ngOnInit() {
  }

  show() {
    this.isActive = true;
    this.canHide = false;
    this.attemptedToHide = false;

    setTimeout(() => {
      this.canHide = true;
      if (this.attemptedToHide) this.hide(this.attemptedToHideDelay);
    }, this.timeout);
  }

  hide(delay: number = 0) {
    if (this.canHide) {
      setTimeout(() => { this.isActive = false; }, delay + 20);
      this.attemptedToHideDelay = 0;
    } else {
      this.attemptedToHide = true;
      this.attemptedToHideDelay = delay;
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/components/inline-spinner-loader/inline-spinner-loader.component.ts